export const baseApi = {
  ccwc: 'contact-center-web-chat',
  version: 'v1',
};
